const ProductCostBasisEnum = {
    FixedPrice: 'FixedPrice',
    Consumption: 'Consumption',
    BasePricePlusConsumption: 'BasePricePlusConsumption',
    ManualEntry: 'ManualEntry',
}

export default ProductCostBasisEnum;